let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1iUSs"), load("jXx9i"), load("dlZSj"), load("9ftJe"), load("jjWia")]).then(() => parcelRequire('liyuV'));